import { render, staticRenderFns } from "./TabPanelAutorizacao.vue?vue&type=template&id=77f7a7b1&"
import script from "./TabPanelAutorizacao.vue?vue&type=script&lang=js&"
export * from "./TabPanelAutorizacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports